import { omitNil } from '../mylib/Utils';
import { authenticated } from './WebRequest';
import type {
  ApiThunk,
  EmailMessageResponse,
  SendEmailParameters,
  SendTestEmailParameters,
} from './types/Email';

export type {
  ApiThunk,
  EmailMessageResponse,
  EmailParameters,
  EmailSettings,
  SendEmailParameters,
  SendSitesEmailParameters,
  SendSitesEmailResponse,
  SendTestEmailParameters,
  SetEmailSettingsParameters,
} from './types/Email';

export default class EmailAPI {
  static send_test_email(
    parameters: SendTestEmailParameters
  ): ApiThunk<EmailMessageResponse> {
    const { ...params } = omitNil(parameters);
    return authenticated.post('/email/send_test_email', { params });
  }

  static send_email(
    parameters: SendEmailParameters
  ): ApiThunk<EmailMessageResponse> {
    const { ...params } = omitNil(parameters);
    return authenticated.post('/email/send_email', { params });
  }
}
